import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/styles.css';
import { galleries } from '../galleryData';

const GalleryImage = ({ src, alt }) => {
  const [status, setStatus] = useState('loading');

  return (
    <>
      {status === 'error' && (
        <div className='image-load-error' role='status'>
          Photograph unavailable
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`portrait-image ${status === 'loaded' ? 'is-loaded' : ''}`}
        loading='lazy'
        onLoad={() => setStatus('loaded')}
        onError={() => setStatus('error')}
      />
    </>
  );
};

const Portrait = () => {
  return (
    <div className='portrait-grid-container'>
      {galleries.map(gallery => (
        <Link
          key={gallery.slug}
          to={`/gallery/${gallery.slug}`}
          className='portrait-card image-container'
          aria-label={`View ${gallery.folder} gallery`}>
          <div className='image-wrapper'>
            <GalleryImage
              src={gallery.featuredImage.src}
              alt={`${gallery.folder} portrait gallery`}
            />
            <div className='overlay-bg'></div>
            <div className='overlay-text'>{gallery.folder}</div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Portrait;
